import { FullCameraViewer } from '@shared/components/camera/full-camera-viewer';
import { useRobotStore } from '@/stores/useRobotStore';
import { getAuthToken } from '@/lib/authToken';

export default function DashboardPage() {
  const cameras = useRobotStore((s) => s.cameras);
  const selectedCameraIds = useRobotStore((s) => s.selectedCameraIds);
  const cameraViewerActive = useRobotStore((s) => s.cameraViewerActive);
  const setCameraViewerActive = useRobotStore((s) => s.setCameraViewerActive);
  const toggleCameraSelection = useRobotStore((s) => s.toggleCameraSelection);
  const token = getAuthToken();

  return (
    <FullCameraViewer
      cameras={cameras}
      selectedIds={selectedCameraIds}
      active={cameraViewerActive}
      onToggle={toggleCameraSelection}
      onActivate={() => setCameraViewerActive(true)}
      onDeactivate={() => setCameraViewerActive(false)}
      className="h-full w-full rounded-none border-0 shadow-none"
      token={token}
    />
  );
}
